module.exports = __webpack_public_path__ + "img/ARC-logo.073f408a.svg";